import { render } from "./news.vue?vue&type=template&id=82af7992&scoped=true&lang=html"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=82af7992&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82af7992"]])

export default __exports__